import React from 'react';
import { Box, Card, CardContent, CardHeader, makeStyles } from "@material-ui/core";
import { Doughnut } from 'react-chartjs-2';

const useStyles = makeStyles((theme) => ({
  cardContent: {

  },
  cardHeader: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingLeft: '25px'
  }
}));

const data = {
  labels: ['Unreconcilled', 'Reconcilled'],
  datasets: [
    {
      label: 'KPIs',
      data: [10, 90],
      backgroundColor: [
        'rgba(255, 99, 132, 0.8)',
        'rgba(75, 192, 192, 0.8)',
      ],
      borderWidth: 1,
    },
  ],
  options: {
    plugins: {
      legend: {
        position: 'top',
      }
    }
  }
};

export default function DashboardDoughnut(props) {
  const classes = useStyles();

  const { title, text } = props;

  return (
    <Card
      variant="outlined"
    >
      <CardHeader
        className={classes.cardHeader}
        title={title}
        titleTypographyProps={{ variant: 'button' }}
      />
      <CardContent className={classes.cardContent}>
        <Box display="flex" justifyContent="center" alignItems='center' paddingBottom='50px'>
          <Box width="80%">
            <Doughnut
              data={data}
              options={{
                cutout: 75,
                responsive: true,
                plugins: {
                  legend: {
                    position: 'top',
                  },
                  title: {
                    display: true
                  }
                }
              }}
            />
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};